/*
 * Migration Lot 3 (2026-04-30) : `AccordionCustom` est désormais bâti sur
 * shadcn/ui (Radix Accordion) au lieu de `@mui/material/Accordion` +
 * `styled`. L'API publique `{ children, title }` est préservée.
 *
 * Différences visuelles à signaler (acceptées par la décision projet
 * « tout shadcn ») :
 *   - L'icône d'expansion shadcn est un chevron à droite qui rotate
 *     vers le bas à l'ouverture (au lieu de la flèche à gauche pivotant
 *     de 90° dans la version MUI). Cohérent avec le reste de shadcn.
 *   - Panel **fermé** au mount (correction post-migration 2026-04-30) :
 *     l'ancien code initialisait `useState('panel1')` mais ne passait
 *     JAMAIS ce state à `<Accordion expanded={...}>` côté MUI — c'était
 *     du dead code, et le rendu réel MUI était fermé par défaut. Pas de
 *     `defaultValue` ici donc Radix Accordion démarre fermé, comme avant.
 *
 * 4 consommateurs : Bilans, Consultation/Tabs/{TabTwo, TabThree, TabFour}.
 */
import * as React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function AccordionCustom({ children, title }) {
  return (
    // `type="single" collapsible` reproduit le comportement MUI : un seul
    // panel ouvert à la fois, et on peut le refermer (ce qui était le cas
    // avec `setExpanded(newExpanded ? panel : false)` dans l'ancien code).
    <Accordion type="single" collapsible className="w-full">
      <AccordionItem
        value="panel1"
        // Bordure complète + fond gris clair sur l'en-tête, repris de
        // l'ancien styled-component MUI.
        className="border rounded-md"
      >
        <AccordionTrigger className="bg-slate-50 hover:bg-slate-100 px-4 py-3 hover:no-underline">
          {title}
        </AccordionTrigger>
        <AccordionContent className="border-t p-4">
          {children}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
